import React from 'react';
import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-go';
import './CodeEditor.css';

/** Mapeo de nuestro valor a la clave de lenguaje en Prism */
const PRISM_LANG = {
  plaintext: null,
  python: 'python',
  javascript: 'javascript',
  typescript: 'typescript',
  html: 'markup',
  css: 'css',
  json: 'json',
  sql: 'sql',
  java: 'java',
  c: 'c',
  cpp: 'cpp',
  php: 'php',
  ruby: 'ruby',
  go: 'go',
};

/**
 * Editor de código con resaltado de sintaxis según el lenguaje.
 * value, onChange, language (ej. 'python', 'javascript'), placeholder, className.
 */
/** Escapa HTML para mostrar código sin resaltar sin romper el DOM */
const escapeHtml = (str) => {
  if (str == null || str === '') return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

const CodeEditor = ({ value = '', onChange, language = 'plaintext', placeholder = '', className = '', style = {} }) => {
  const prismLang = PRISM_LANG[language] || null;

  const highlightCode = (code) => {
    const text = code || '';
    const gram = prismLang && Prism.languages[prismLang];
    if (!prismLang || !gram || typeof gram !== 'object') return escapeHtml(text);
    try {
      return Prism.highlight(text, gram, prismLang);
    } catch (e) {
      return escapeHtml(text);
    }
  };

  return (
    <Editor
      value={value}
      onValueChange={onChange}
      highlight={highlightCode}
      padding={12}
      placeholder={placeholder}
      className={className}
      style={{
        fontFamily: '"Consolas", "Monaco", "Courier New", monospace',
        fontSize: '0.875rem',
        lineHeight: 1.5,
        minHeight: '280px',
        color: '#e8e8e8',
        background: '#2d2d2d',
        ...style,
      }}
      textareaClassName="code-editor-textarea"
    />
  );
};

export default CodeEditor;
export { PRISM_LANG };
